/* @flow */
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';

export const AVAILABLE_WALLET = 'available';
export const PENDING_WALLET = 'pending';
export const STRIPE_ACCOUNT_TYPE_INDIVIDUAL = 'individual';
export const STRIPE_COUNTRY = 'US';
export const STRIPE_CURRENCY = 'USD';
export const USD_CURRENCY = 'usd';

const STRIPE_BASIC_VERIFICATIONS = [
  'legal_entity.dob.day',
  'legal_entity.dob.month',
  'legal_entity.dob.year',
  'legal_entity.first_name',
  'legal_entity.last_name',
];

const STRIPE_ADDITIONAL_VERIFICATIONS = [
  'legal_entity.personal_id_number',
];

const STRIPE_BANK_ACCOUNT_VERIFICATION = 'external_account';

class PaymentAccount extends Entity {
  isTransferEnabled() {
    return this.get('transfers_enabled');
  }

  getBalance() {
    return this.get('balance');
  }

  needAdditionalVerification() {
    return this.needVerifications(STRIPE_ADDITIONAL_VERIFICATIONS);
  }

  needBasicVerification() {
    return this.needVerifications(STRIPE_BASIC_VERIFICATIONS);
  }

  needBankAccountVerification() {
    return this.needVerifications([STRIPE_BANK_ACCOUNT_VERIFICATION]);
  }

  // $FlowFixMe
  needVerifications(verifications) {
    return !!this.get('verification')['fields_needed'].find(field =>
      verifications.includes(field)
    );
  }

  getBalanceAmount(wallet: string, currency: string = USD_CURRENCY) {
    const balance = this.getBalance();

    if (balance && balance[wallet]) {
      const currencyBalance = balance[wallet].find(
        w => w.currency === currency
      );

      if (currencyBalance) {
        return currencyBalance.amount;
      }
    }

    return null;
  }

  hasProvidedPersonalIdNumber() {
    return !!this.get('personal_id_number_provided');
  }

  getAvailableBalanceAmount(currency: string = USD_CURRENCY) {
    return this.getBalanceAmount(AVAILABLE_WALLET, currency);
  }

  getPendingBalanceAmount(currency: string = USD_CURRENCY) {
    return this.getBalanceAmount(PENDING_WALLET, currency);
  }

  static load() {
    return apiRequest('/payments/account', 'GET')
      .then(response => PaymentAccount.fromJSON(response));
  }

  static patch(account) {
    return apiRequest('/payments/account', 'PATCH', { account })
      .then(response => PaymentAccount.fromJSON(response));
  }

  // pii = personally identifiable information
  static patchPII(piis) {
    return apiRequest('/payments/account/pii', 'PATCH', { account: piis })
      .then(response => PaymentAccount.fromJSON(response));
  }

  static addBankAccount(token) {
    return apiRequest('/payments/payment_destinations', 'POST', { token })
      .then(response => PaymentAccount.fromJSON(response));
  }

  static requestVerificationHelp() {
    return apiRequest('/payments/account/need_manual_verification', 'POST');
  }
}

export default PaymentAccount;



// WEBPACK FOOTER //
// ./src/entities/PaymentAccount.js